/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const getConfig = () => ({
 sitecoreApiKey: process.env.SITECORE_API_KEY || 'no-api-key-set',
 sitecoreApiHost: process.env.SITECORE_API_HOST || 'http://njord-store-cm',
 sitecoreSiteName: process.env.SITECORE_SITE_NAME || 'njord-store',
 graphQLEndpointPath: process.env.GRAPH_QL_ENDPOINT_PATH || '/sitecore/api/graph/edge',
 defaultLanguage: process.env.DEFAULT_LANGUAGE || 'en',
 isrRevalidateInterval: process.env.ISR_REVALIDATE_INTERVAL || 'undefined',
 dictionaryCacheInterval: process.env.DICTIONARY_CACHE_INTERVAL || 'undefined',
 layoutServiceConfigurationName: process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || 'default',
 publicUrl: process.env.PUBLIC_URL || 'http://localhost:3000',
 productCatalogueBaseUrl: process.env.PRODUCT_CATALOGUE_BASE_URL || 'undefined',
 productCatalogueApiKey: process.env.PRODUCT_CATALOGUE_API_KEY || 'undefined',
 siteSettingsApiBaseUrl: process.env.SITE_SETTINGS_API_BASE_URL || 'undefined',
 marketingDocumentsBaseUrl: process.env.MARKETING_DOCUMENTS_BASE_URL || 'undefined',
 knowledgebaseApiBaseUrl: process.env.KNOWLEDGEBASE_API_BASE_URL || 'undefined',
 coveoUserAnalyticsAccessToken: process.env.COVEO_USER_ANALYTICS_ACCESS_TOKEN || 'undefined',
 coveoUserAnalyticsEndpoint: process.env.COVEO_USER_ANALYTICS_ENDPOINT || 'undefined',
 graphQLEndpoint: process.env.GRAPH_QL_ENDPOINT || 'http://njord-store-cm/sitecore/api/graph/edge',
});
module.exports = getConfig;